import { z } from 'zod'

const envSchema = z.object({
  NODE_ENV: z.enum(['development', 'staging', 'production', 'test']),
  PROJECT_ID: z.string().min(1).optional(),
})

// Manually construct the env object since webpack transforms individual properties
// but not the entire process.env object
const envVars = {
  NODE_ENV: process.env.NODE_ENV,
  PROJECT_ID: process.env.PROJECT_ID,
}

export const env = envSchema.parse(envVars)

// Deployed bundles are built with webpack `mode: 'production'`, so this is only true on a developer's machine.
export const isLocalDevelopment = env.NODE_ENV === 'development'
